import { render, staticRenderFns } from "./hpfooter.vue?vue&type=template&id=63da5431&scoped=true"
import script from "./hpfooter.vue?vue&type=script&lang=js"
export * from "./hpfooter.vue?vue&type=script&lang=js"
import style0 from "./hpfooter.vue?vue&type=style&index=0&id=63da5431&prod&lang=css"
import style1 from "./hpfooter.vue?vue&type=style&index=1&id=63da5431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da5431",
  null
  
)

export default component.exports